
import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
import { imgStoragePath } from '../../constants'
export default class DeploymentMessage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            deploymentFlag: false
        }
    }
    render() {
        const { deploymentFlag } = this.state
        let marginVal = this.props.margin
        let marginbottom = this.props.marginbottom
        return (
            <>
                {
                    deploymentFlag ?
                            <Grid item sm="12">
                                <p className="deployment-info" style={this.props.marginbottom ? {marginBottom:marginbottom}: null}>
                                    {/* <span >SPARTA will be under heavy maintenance activity from <h6>23rd Dec UTC 18:30 hrs to 25th Dec UTC 18:30 hrs </h6>. Upload functionalities will be impacted during these days. Apologies for the inconvenience caused.</span> */}
                                    <span>Please be informed that due to Emergency Core Infrastructure Maintenance at hosting server access to SPARTA may be intermittent from 2025-04-22 13:00 UTC to 2025-04-22 19:00 UTC.</span>
                                    <span >
                                        <img width="13" onClick={() => { this.setState({ deploymentFlag: false }) }} src={imgStoragePath + "toast_cross.png"} alt="Close Icon"/>
                                    </span>
                                </p>
                            </Grid>
                        :
                        null}
            </>
        )
    }
}